export enum GroundingEnum {
    GROUNDED = "GROUNDED",
    NOT_GROUNDED = "NOT_GROUNDED",
}

export type GroundingStrings = (typeof GroundingEnum)[keyof typeof GroundingEnum];


export interface BranchInterface {
    id?: number;
    is_active?: boolean;
    name?: string;
    start_node_id?: number;
    end_node_id?: number;
    project_id?: number;

    R1?: number;
    X1?: number
    B1?: number;
    G1?: number;
    start_node_u_nom?: number;
    end_node_u_nom?: number;
    transformer_angle?: number;

    R0?: number;
    X0?: number;
    B0?: number;
    G0?: number;
}


export interface CreateOrUpdateBranchInterface {
    is_active?: boolean;
    name?: string;
    start_node_id?: number;
    end_node_id?: number;
    project_id?: number;

    R1?: number;
    X1?: number;
    B1?: number;
    G1?: number;
    start_node_u_nom?: number;
    end_node_u_nom?: number;
    transformer_angle?: number;

    R0?: number;
    X0?: number;
    B0?: number;
    G0?: number;
}
